/* Brown Butter – Book Details (sections/bb-book-details.liquid).
   Dust jacket, signature and provenance are stored per variant (per copy), so when the shopper picks another
   Condition this section is re-rendered for that variant with the Section Rendering API. */
if (!customElements.get('bb-book-details')) {
  customElements.define(
    'bb-book-details',
    class BBBookDetails extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data && event.data.variant;
          if (!variant || variant.id === this.variantId) return;
          // Ignore variant changes from quick-add modals of other products.
          if (event.data.sectionId && !document.getElementById(`MainProduct-${event.data.sectionId}`)) return;
          this.variantId = variant.id;
          this.refresh(variant.id);
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      refresh(variantId) {
        const url = `${this.dataset.url}?variant=${variantId}&section_id=${this.dataset.section}`;
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            if (variantId !== this.variantId) return;
            const html = new DOMParser().parseFromString(text, 'text/html');
            const fresh = html.querySelector('bb-book-details');
            if (!fresh) return;
            this.innerHTML = fresh.innerHTML;
            this.hidden = fresh.hasAttribute('hidden');
          })
          .catch(() => {});
      }
    }
  );
}
